import {FormProvider, useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import {EditDiscountCodeFormValuesV2} from "../types";
import {Button} from "antd";
import {useEffect} from "react";
import {CodeNameFormFieldV2} from "../../create-discount-code/code-name-form-field-v2";
import {DiscountCodeOfferingsFormFieldV2} from "../../create-discount-code/offerings-form-field-v2";
import {DiscountCodeCustomersFormFieldV2} from "../../create-discount-code/customers-form-field-v2";
import {DiscountCodeUsageFormFieldV2} from "../../create-discount-code/usage-form-field-v2";
import {DiscountCodeValidityFormFieldV2} from "../../create-discount-code/validity-form-field-v2";
import {DiscountCodeSettingsFormFieldV2} from "../form-v2/settings-form-field";
import {useUpdateDiscountCodeV2} from "../hooks/update-discount-code-v2";
import {getDiscountCodeFormSchema} from "../../create-discount-code/form-validation-schema";
import {
  StyledDiscountFormButtonWrapper,
  StyledDiscountFormWrapper,
} from "../../create-discount-code/styles/discount-form.styles";

export function EditDiscountPageV2() {
  const {defaultFormValues, isUpdatingDiscountCode, updateDiscountCode} =
    useUpdateDiscountCodeV2();

  const formMethods = useForm<EditDiscountCodeFormValuesV2>({
    resolver: yupResolver(getDiscountCodeFormSchema()),
    mode: "onSubmit",
    defaultValues: {
      ...defaultFormValues,
    },
  });

  useEffect(() => {
    formMethods.reset(defaultFormValues);
  }, [defaultFormValues, formMethods]);

  return (
    <StyledDiscountFormWrapper>
      <FormProvider {...formMethods}>
        <form onSubmit={formMethods.handleSubmit(updateDiscountCode)} autoComplete="off">
          <CodeNameFormFieldV2 />
          <DiscountCodeOfferingsFormFieldV2 />
          <DiscountCodeCustomersFormFieldV2 />
          <DiscountCodeUsageFormFieldV2 />
          <DiscountCodeValidityFormFieldV2 />
          <DiscountCodeSettingsFormFieldV2 />

          <StyledDiscountFormButtonWrapper>
            <Button
              className="btn-primary"
              // size="large"
              type="primary"
              htmlType="submit"
              loading={isUpdatingDiscountCode}
              disabled={
                Object.keys(formMethods.formState.errors).length > 0 ||
                Object.values(formMethods.watch()).length < 1
              }
            >
              Save changes
            </Button>
            <Button
              className="btn-secondary"
              onClick={() => formMethods.reset()}
              // size="large"
              type="default"
            >
              Discard changes
            </Button>
          </StyledDiscountFormButtonWrapper>
        </form>
      </FormProvider>
    </StyledDiscountFormWrapper>
  );
}
